function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Avatar, Box, Card, FileIcon, Flex, GridAlpha, Heading, Link, Markdown, Tabs, Tag, Text, Tooltip, useId, Notice } from '@applyboard/crystal-ui';
import { DocumentOutlineIcon, InfoOutlineIcon, ListCheckOutlineIcon } from '@applyboard/ui-icons';
import { useTranslation } from '@applyboard/ui-utils';
import { getRequirementStatusInfo, getRequirementTitle, simulateUnfulfillableRequirement, simulateApplicantRequirementView } from "./RequirementCard.utils";
import { formatTimelessDateStr } from "../../utils/dates";
import { RawHtml } from "../RawHtml";
import { match } from 'ts-pattern';

/**
 * These are the possible events sent by the onEvent callback below
 */
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export var RequirementCard = function RequirementCard(props) {
  var headingId = useId();
  return _jsxs(Card, {
    "aria-labelledby": headingId,
    selected: props.selected,
    children: [props.href && _jsx(Card.Linked, {
      "aria-label": "View requirement details",
      href: props.href
    }), props.requirement.classification === 'applicant_requirement' && props.requirement.internalTitle && !props.isCompactLayout ? _jsx(RequirementCardTabbedContents, _objectSpread(_objectSpread({}, props), {}, {
      headingId: headingId,
      onTabChange: function onTabChange(newTab) {
        if (newTab === 'applicant') {
          var _props$onEvent;
          (_props$onEvent = props.onEvent) === null || _props$onEvent === void 0 ? void 0 : _props$onEvent.call(props, 'applicant_tab_selected');
        }
      }
    })) : _jsx(RequirementCardContents, _objectSpread(_objectSpread({}, props), {}, {
      headingId: headingId
    }))]
  });
};
var RequirementCardTabbedContents = function RequirementCardTabbedContents(props) {
  var _useState = useState('admin'),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var _useTranslation = useTranslation('RequirementCard'),
    t = _useTranslation.t;
  return _jsxs(Tabs, {
    onChange: function onChange(newValue) {
      setCurrentTab(newValue);
      props.onTabChange(newValue);
    },
    value: currentTab,
    children: [_jsx(Tabs.Item, {
      value: "admin",
      label: t('tabTitles.admin'),
      children: _jsx(RequirementCardContents, _objectSpread(_objectSpread({}, props), {}, {
        requirement: simulateUnfulfillableRequirement(props.requirement)
      }))
    }), _jsx(Tabs.Item, {
      value: "applicant",
      label: t('tabTitles.applicant'),
      children: _jsx(RequirementCardContents, _objectSpread(_objectSpread({}, props), {}, {
        requirement: simulateApplicantRequirementView(props.requirement)
      }))
    })]
  });
};
var RequirementCardContents = function RequirementCardContents(_ref) {
  var _requirement$response, _answersHistory$;
  var amount = _ref.amount,
    headingId = _ref.headingId,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? 3 : _ref$headingLevel,
    isCompactLayout = _ref.isCompactLayout,
    message = _ref.message,
    numAttachmentsUploaded = _ref.numAttachmentsUploaded,
    numQuestionsAnswered = _ref.numQuestionsAnswered,
    renderActions = _ref.renderActions,
    renderDetailsButton = _ref.renderDetailsButton,
    renderProvideAnswersButton = _ref.renderProvideAnswersButton,
    requirement = _ref.requirement;
  var deadline = requirement.deadline,
    flags = requirement.flags,
    status = requirement.status;
  var _useTranslation2 = useTranslation('RequirementCard'),
    t = _useTranslation2.t;
  var _getRequirementStatus = getRequirementStatusInfo({
      requirement: requirement
    }),
    Icon = _getRequirementStatus.Icon,
    intent = _getRequirementStatus.intent;
  var answersHistory = requirement === null || requirement === void 0 ? void 0 : (_requirement$response = requirement.responses) === null || _requirement$response === void 0 ? void 0 : _requirement$response.answersHistory;
  var autoProcessed = Boolean(answersHistory === null || answersHistory === void 0 ? void 0 : answersHistory.some(function (answer) {
    return answer.evaluatedBy === 'applyboard_automation';
  }));
  var showAutoSubmittedNotice = status === 'reviewing' && (answersHistory === null || answersHistory === void 0 ? void 0 : (_answersHistory$ = answersHistory[0]) === null || _answersHistory$ === void 0 ? void 0 : _answersHistory$.submittedBy) === 'applyboard_requirement_synchronization';
  var requirementStatusLabel = requirement.classification !== 'applicant_requirement' && status === 'missing' ? t('requirementStatus.missingAdmin') : t("requirementStatus.".concat(status));
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsx("header", {
      children: _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [message, showAutoSubmittedNotice && _jsx(Notice, {
          intent: "secondary",
          children: t('autoProcessedNotice')
        }), _jsxs(GridAlpha, {
          areas: {
            xs: ['requirementHeader actions', 'provideAnswersButton provideAnswersButton'],
            sm: ['requirementHeader provideAnswersButton actions']
          },
          columns: {
            xs: '1fr auto',
            sm: '1fr auto auto'
          },
          columnGap: 2,
          rowGap: 2,
          children: [_jsx(GridAlpha.Item, {
            areaName: "requirementHeader",
            children: _jsxs(Flex, {
              align: {
                xs: 'start',
                sm: isCompactLayout ? 'start' : 'center'
              },
              gap: 2,
              children: [_jsx(Flex.Item, {
                basis: 32,
                grow: 0,
                shrink: 0,
                children: _jsx(Avatar, {
                  "aria-label": requirementStatusLabel,
                  emphasis: "highlighted",
                  icon: Icon,
                  intent: intent,
                  size: "xs"
                })
              }), _jsxs(Flex, {
                direction: {
                  xs: 'column',
                  sm: isCompactLayout ? 'column' : 'row'
                },
                gap: 3,
                align: {
                  xs: 'start',
                  sm: isCompactLayout ? 'start' : 'center'
                },
                children: [_jsxs(Heading, {
                  id: headingId,
                  level: headingLevel,
                  variant: "titleS",
                  wordBreak: "word",
                  children: [getRequirementTitle({
                    requirement: requirement
                  }), " ", amount ? "(".concat(amount, ")") : '']
                }), _jsx(Box, {
                  hideBelow: "sm",
                  children: _jsx(TitleTags, {
                    deadline: deadline,
                    flags: flags
                  })
                })]
              })]
            })
          }), _jsx(GridAlpha.Item, {
            areaName: "provideAnswersButton",
            children: renderProvideAnswersButton === null || renderProvideAnswersButton === void 0 ? void 0 : renderProvideAnswersButton({
              requirement: requirement
            })
          }), _jsx(GridAlpha.Item, {
            areaName: "actions",
            children: renderActions === null || renderActions === void 0 ? void 0 : renderActions({
              requirement: requirement
            })
          })]
        }), _jsx(Box, {
          hideAbove: "sm",
          children: _jsx(TitleTags, {
            deadline: deadline,
            flags: flags
          })
        })]
      })
    }), _jsxs(Flex, {
      direction: "column",
      gap: 4,
      children: [_jsx(DescriptionAndLinks, {
        requirement: requirement,
        isCompactLayout: isCompactLayout,
        headingSettings: {
          baseLevel: getNextHeadingLevel(headingLevel)
        }
      }), _jsx(AdditionalTags, {
        flags: _objectSpread(_objectSpread({}, flags), {}, {
          autoProcessed: autoProcessed
        })
      }), _jsxs(Flex, {
        gap: 4,
        align: "center",
        wrap: true,
        children: [(numQuestionsAnswered !== undefined || numAttachmentsUploaded !== undefined) && _jsxs(Flex, {
          gap: 4,
          wrap: true,
          children: [numQuestionsAnswered !== undefined && _jsxs(Flex, {
            gap: 2,
            children: [_jsx(ListCheckOutlineIcon, {
              intent: "secondary",
              contrast: "mid"
            }), _jsx(Text, {
              intent: "secondary",
              variant: "labelM",
              contrast: "mid",
              overflow: "nowrap",
              children: t("attachmentTags.questionsAnswered", {
                count: numQuestionsAnswered
              })
            })]
          }), numAttachmentsUploaded !== undefined && _jsxs(Flex, {
            gap: 2,
            children: [_jsx(DocumentOutlineIcon, {
              intent: "secondary",
              contrast: "mid"
            }), _jsx(Text, {
              intent: "secondary",
              variant: "labelM",
              contrast: "mid",
              overflow: "nowrap",
              children: t("attachmentTags.documentsUploaded", {
                count: numAttachmentsUploaded
              })
            })]
          })]
        }), renderDetailsButton && _jsx(Flex, {
          as: "footer",
          justify: "end",
          grow: 1,
          children: renderDetailsButton({
            requirement: requirement
          })
        })]
      })]
    })]
  });
};
function SupplementalLinks(_ref2) {
  var supplementalLinks = _ref2.supplementalLinks;
  return _jsx(_Fragment, {
    children: supplementalLinks === null || supplementalLinks === void 0 ? void 0 : supplementalLinks.map(function (link) {
      return _jsx(Box, {
        pt: 3,
        pb: 3,
        children: _jsx(Text, {
          overflow: "ellipsis",
          children: _jsx(Link, {
            href: link,
            mode: "override_user_choice_and_open_in_new_tab",
            children: link.replace(/^(http:\/\/|https:\/\/)/, '')
          })
        })
      }, link);
    })
  });
}
function SupplementalAttachments(_ref3) {
  var supplementalAttachments = _ref3.supplementalAttachments;
  return _jsx(_Fragment, {
    children: supplementalAttachments === null || supplementalAttachments === void 0 ? void 0 : supplementalAttachments.map(function (attachment, index) {
      return _jsxs(Flex, {
        direction: "row",
        align: "center",
        gap: 2,
        children: [_jsx(FileIcon, {
          fileName: attachment.fileName,
          intent: "primary"
        }), _jsx(Text, {
          overflow: "ellipsis",
          children: _jsx(Link, {
            href: attachment.fileDownloadLink,
            mode: "override_user_choice_and_open_in_new_tab",
            variant: "standalone",
            children: attachment.fileName
          })
        })]
      }, index);
    })
  });
}
function DescriptionPreview(_ref4) {
  var requirement = _ref4.requirement,
    headingSettings = _ref4.headingSettings,
    disableTruncation = _ref4.disableTruncation;
  var truncationSettings = disableTruncation ? undefined : {
    maxChars: 50,
    srOnlyText: "details about ".concat(requirement.title)
  };
  var finalHeadingSettings = _objectSpread({
    styles: {
      h1: {
        variant: 'bodyM',
        contrast: 'mid',
        bold: true
      }
    }
  }, headingSettings);
  return requirement.type === 'application_hybrid_requirement' ? _jsx(Markdown, {
    markdown: requirement.internalDescription || requirement.description,
    headingSettings: finalHeadingSettings,
    truncationSettings: truncationSettings
  }) : _jsx(RawHtml, {
    dangerouslySetInnerHTML: {
      __html: requirement.internalDescription || requirement.description
    },
    truncationSettings: truncationSettings
  });
}
export function DescriptionAndLinks(_ref5) {
  var requirement = _ref5.requirement,
    headingSettings = _ref5.headingSettings,
    isCompactLayout = _ref5.isCompactLayout,
    disableTruncation = _ref5.disableTruncation;
  return _jsxs(Flex, {
    direction: "column",
    children: [!isCompactLayout && _jsx(DescriptionPreview, {
      requirement: requirement,
      headingSettings: headingSettings,
      disableTruncation: disableTruncation
    }), _jsx(SupplementalLinks, {
      supplementalLinks: requirement.supplementalLinks
    }), _jsx(SupplementalAttachments, {
      supplementalAttachments: requirement.supplementalAttachments
    })]
  });
}
var AdditionalTags = function AdditionalTags(_ref6) {
  var flags = _ref6.flags;
  var _useTranslation3 = useTranslation('RequirementCard'),
    t = _useTranslation3.t;
  var additionalTags = {
    applyboardRequirement: flags.applyboardRequirement,
    autoProcessed: flags.autoProcessed,
    modified: flags.modified,
    manual: flags.manual
  };
  var tags = Object.keys(additionalTags).filter(function (flag) {
    return additionalTags[flag] === true;
  });
  if (tags.length === 0) {
    return null;
  }
  return _jsx(Flex, {
    direction: "row",
    gap: 2,
    wrap: true,
    children: tags.map(function (tag, index) {
      return _jsx(Tag, {
        intent: "secondary",
        children: t("additionalTags.".concat(tag))
      }, index);
    })
  });
};
var TitleTags = function TitleTags(_ref7) {
  var deadline = _ref7.deadline,
    flags = _ref7.flags;
  var _useTranslation4 = useTranslation('RequirementCard'),
    t = _useTranslation4.t;
  if (!deadline && !flags.earlyAccess && !flags.optional && !flags.requiredBeforePayment) {
    return null;
  }
  return _jsxs(Flex, {
    gap: 2,
    wrap: true,
    children: [deadline && _jsx(Tag, {
      intent: "warning",
      size: "sm",
      children: "".concat(t('titleTags.dueDate'), " ").concat(formatTimelessDateStr(deadline, 'MMM Do, YYYY'))
    }), flags.earlyAccess && flags.optional && _jsx(Tooltip, {
      label: t('titleTags.earlyAccessTooltip'),
      children: _jsx(Tag, {
        as: "button",
        intent: "magic",
        icon: InfoOutlineIcon,
        size: "sm",
        children: t('titleTags.earlyAccess')
      })
    }), flags.optional && _jsx(Tag, {
      intent: "primary",
      size: "sm",
      children: t('titleTags.optional')
    }), flags.requiredBeforePayment && _jsx(Tag, {
      intent: "warning",
      children: t('beforePayment')
    })]
  });
};
function getNextHeadingLevel(headingLevel) {
  return match(headingLevel)["with"](2, function () {
    return 3;
  })["with"](3, function () {
    return 4;
  })["with"](4, function () {
    return 5;
  })["with"](5, function () {
    return 6;
  }).exhaustive();
}